import SelectEventForInsurance from "../../../Components/Insurance/SelectEvent/SelectEvet";

export default function HomeInsurance() {
    return (
        <>
            <SelectEventForInsurance />
        </>
    )
}